/* eslint-disable no-new */
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/main.scss";

import Vue from "vue";
import App from "./App";
import router from "./router";
import Vuex from "vuex";
import AsyncComputed from "vue-async-computed";
import VueSimpleSVG from "vue-simple-svg";
import VTooltip from "v-tooltip";
import { ClientTable } from "vue-tables-2";
import createPersistedState from "vuex-persistedstate";
import { some, omit, findIndex } from "lodash";
import vSelect from "vue-select";
import vAb from "vue-ab";

let getEnv = () => {
  return window.location.hostname.indexOf("test.") >= 0
    ? "test"
    : window.location.hostname.indexOf("localhost") >= 0
    ? "dev"
    : "prod";
};

window.FILES_URL = require(`../config/${getEnv()}.env`).FILES_URL;

Vue.component("v-select", vSelect);
Vue.component("v-ab", vAb);
Vue.use(VTooltip);
Vue.use(ClientTable);
Vue.use(VueSimpleSVG);
Vue.use(AsyncComputed);
Vue.use(Vuex);

window.MP_TOKEN = require(`../config/${getEnv()}.env`).MP_TOKEN;

const store = new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    user: {},
    lastAddress: {
      facturacion: {},
      envio: {}
    },
    token: "",
    search: {},
    cart: [],
    discountCode: "",
    checkoutCart: [],
    showList: false,
    query: {
      ancho: null,
      alto: null,
      largo_cadena: null
    },
    productData: []
  },
  mutations: {
    setLastAddress(state, value) {
      state.lastAddress = value;
    },
    setSearch(state, value) {
      state.search = value;
    },
    mutate(state, payload) {
      state[payload.key] = payload.value;
    },
    addToCart(state, payload) {
      const productsWithoutQuantity = state.cart.map(product =>
        omit(product, ["quantity", "price"])
      );
      const payloadWithoutQuantity = omit(payload, [
        "quantity",
        "price",
        "subtotal"
      ]);

      if (some(productsWithoutQuantity, payloadWithoutQuantity)) {
        const index = findIndex(
          productsWithoutQuantity,
          payloadWithoutQuantity
        );
        state.cart.splice(index, 1, {
          ...payloadWithoutQuantity,
          quantity: state.cart[index].quantity + payload.quantity
        });
      } else {
        state.cart = [...state.cart, payload];
      }
    },
    prepareCartForCheckout(state, payload) {
      state.checkoutCart = payload;
    },
    deleteItemFromCart(state, payload) {
      const productsWithoutQuantity = state.cart.map(product =>
        omit(product, ["quantity", "price"])
      );

      const payloadWithoutQuantity = omit(payload, ["quantity", "price", "subtotal"]);

      const index = findIndex(productsWithoutQuantity, payloadWithoutQuantity);
      state.cart.splice(index, 1);
    },
    clearCart(state) {
      state.cart = [];
      state.discountCode = "";
    },
    setDiscount(state, data) {
      state.discountCode = data;
    },
    addQuery(state, data) {
      state.query = {
        ancho: data.query.ancho,
        alto: data.query.alto,
        largo_cadena: data.query.largo_cadena
      };
    },
    setShowList(state, data) {
      // state.showList = !state.showList
      state.showList = true;
    }
  }
});

new Vue({
  el: "#app",
  data: {
    renders: require("../helpers/renders")
  },
  store,
  router,
  components: { App },
  template: "<App/>",
  methods: {
    getColorName(telaKey, name) {
      let fullname = `${telaKey}|${name}`;
      let names = {
        "black-out|black-out-blanco": "BO blanco",
        "black-out|black-out-natural": "BO natural",
        "black-out|black-out-beige": "BO beige",
        "black-out|black-out-gris": "BO gris claro",
        "black-out|black-out-gris-topo": "BO gris oscuro",
        "black-out|black-out-negro": "BO negro",

        "verso|verso-blanco-beige": "1% Beige",
        "verso|verso-blanco-blanco": "1% Blanco",
        "verso|verso-blanco-gris": "1% Gris",
        "verso|verso-bicolor-gris":  "1% Bicolor Gris",
        "verso|verso-bicolor-marron":  "1% Bicolor Marrón",

        "deco|deco-blanco-blanco": "3% Blanco",
        "deco|deco-blanco": "3% Lino",
        "deco|deco-linnen": "3% Linnen",
        "deco|deco-blanco-gris": "3% Perla",
        "deco|deco-antracita-manda": "3% Antracita",
        "deco|deco-chocolate-bronce": "3% Bronce",
        "deco|deco-plata": "3% Obsidiana",
        "deco|deco-negro": "3% Negro",

        "poliscreen|poliscreen-blanco": "Eco. Blanco",
        "poliscreen|poliscreen-natural": "Eco. Natural",
        "poliscreen|poliscreen-beige": "Eco. Beige",
        "poliscreen|poliscreen-blanco-gris": "Eco. Gris",
        "poliscreen|poliscreen-bicolor-marron": "Eco. Bicolor Marrón",
        "poliscreen|poliscreen-bicolor-azul": "Eco. Bicolor Azul",
        "poliscreen|poliscreen-ushu-blanco": "Nogal Blanco",
        "poliscreen|poliscreen-crudo": "Nogal Beige",
        "poliscreen|poliscreen-iguazu-blanco": "Acacia Blanco",
        "poliscreen|poliscreen-iguazu-natural": "Acacia Natural",
        "poliscreen|poliscreen-durazno": "Acacia Beige",
        "poliscreen|poliscreen-iguazu-grisoscuro": "Acacia Gris Oscuro",
        "poliscreen|p-algodon": "Álamo Blanco",
        "poliscreen|p-algodon2": "Álamo Algodón",
        "poliscreen|p-crudo": "Álamo Crudo",
        "poliscreen|poliscreen-lino": "Álamo Lino",
        "poliscreen|p-linnen": "Álamo Linnen",
        "poliscreen|poliscreen-gris-claro": "Álamo Gris Claro",
        "poliscreen|poliscreen-gris-oscuro": "Álamo Gris Oscuro",
        "poliscreen|p-pampa-linnen": "Cedro Linnen",
        "poliscreen|p-pampa-gris": "Cedro Gris",
        "poliscreen|p-pampa-blanco": "Cedro Blanco",
        "poliscreen|p-pampa-crudo": "Cedro Crudo",

        "natte|natte-blanco-blanco": "5% Blanco",
        "natte|natte-blanco-beige": "5% Beige",
        "natte|natte-blanco-gris": "5% Gris",
        "natte|natte-chocolate-negro": "5% Marrón",
        "natte|natte-negro-negro": "5% Negro",
        "natte|natte-desierto": "5% Desierto",
        "natte|natte-glaciar": "5% Glaciar",
        "natte|natte-corteza": "5% Corteza",
        "natte|natte-volcánico": "5% Volcánico",
        "natte|natte-colorin-azul": "5% Turquesa",
        "natte|natte-colorin-verde": "5% Verde",
        "natte|natte-colorin-amarillo": "5% Amarillo",
        "natte|natte-colorin-mandarina": "5% Naranja",
        "natte|natte-demin-rosa": "5% Denim Rosa",
        "natte|natte-demin-celeste": "5% Denim Celeste",
        "natte|natte-demin-verde": "5% Denim Verde",
        "natte|natte-costa": "Rústica Costa",
        "natte|natte-pantano": "Rústica Pantana",
        "natte|natte-cuenca": "Rústica Cuenca",
        "natte|natte-meseta": "Elegance Meseta",
        "natte|natte-estepa": "Elegance Estepa",
        "natte|natte-llanura": "Elegance Llanura",
      };
      return names[fullname] ? names[fullname] : name;
    },
    getRenderImage(product, tela, line = 0) {
      if (
        product === "BANDASVERTICALES" &&
        tela &&
        tela.indexOf("black-out") >= 0
      ) {
        return this.fallbackRender(product);
      } else if (product === "PANELORIENTALES") {
        let render = "Paneles_Orientales_";
        if (!tela) {
          return this.fallbackRender(product);
        } else if (tela.indexOf("black-out") >= 0) {
          render = render + "blackout";
        } else if (line === "verso") {
          render = render + "1";
        } else if (line === "deco") {
          render = render + "3";
        } else if (line === "natte") {
          render = render + "5";
        }
        return `/static/images/renders/${render}.jpg`;
      } else if (product === "CORTINASCONBARRAL") {
        let render = "Cortina_barral_";
        if (!tela) {
          return this.fallbackRender(product);
        } else if (tela.indexOf("blackout-textil") >= 0) {
          render = render + "blackout-textil";
        } else if (tela.indexOf("lino-rustico") >= 0) {
          render = render + "lino-rustico";
        } else if (tela.indexOf("panama") >= 0) {
          render = render + "panama";
        } else if (tela.indexOf("rustica-liviana") >= 0) {
          render = render + "rustica-liviana";
        } else if (tela.indexOf("voile-granite") >= 0) {
          render = render + "voile-granite";
        } else return this.fallbackRender(product);
        return `/static/images/renders/${render}.jpg`;
      } else if (product === "BANDASVERTICALES") {
        let render = "Cortina_Vertical_";
        if (tela === "natte-blanco-beige") render = render + "beige";
        else if (tela === "natte-blanco-blanco") render = render + "blanco";
        else if (tela === "natte-blanco-perla") render = render + "marron";
        else if (tela === "natte-negro-negro") render = render + "negra";
        else return this.fallbackRender(product);
        return `https://d23e8pcs5gsiak.cloudfront.net/static/images/renders/${render}.jpg`;
      } else if (this.renders[tela]) {
        return `https://d23e8pcs5gsiak.cloudfront.net/static/images/renders/${tela
          .replace("á", "a")
          .replace("é", "e")
          .replace("í", "i")
          .replace("ó", "o")
          .replace("ú", "u")}.jpg`;
      } else {
        return this.fallbackRender(product);
      }
    },
    fallbackRender(product) {
      if (product === "PANELORIENTALES") {
        return this.renders.fallback_orientales;
      } else if (product === "CORTINASCONBARRAL") {
        return this.renders.fallback_barral;
      } else if (product === "MOSQUITERA-ENROLLABLE") {
        return this.renders.fallback_mosquitera;
      } else if (product === "ROLLER" || product === "ROLLERDOBLE") {
        return this.renders.fallback_roller;
      } else if (product === "DUO") {
        return this.renders.fallback_duo;
      }
      return this.renders.fallback_vertical;
    },
    getAnalyticsProductsFromCart() {
      return this.$store.state.cart.map(item => {
        return {
          product_id: item.productData.entity_id,
          sku: item.productData.sku,
          category: item.productData.Name,
          name: item.productData.Name,
          brand: "CortinasOnline",
          variant: "",
          url: "https://cortinasonline.com/cotizador",
          image_url: this.getRenderImage(
            item.productData.sku,
            item.options.Color
          )
        };
      });
    }
  }
});



// WEBPACK FOOTER //
// ./src/main.js